import { render } from "./SuccessDialog.vue?vue&type=template&id=514b0fcb&scoped=true"
import script from "./SuccessDialog.vue?vue&type=script&lang=js"
export * from "./SuccessDialog.vue?vue&type=script&lang=js"

import "./SuccessDialog.vue?vue&type=style&index=0&id=514b0fcb&lang=scss&scoped=true"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-514b0fcb"]])

export default __exports__